import NewReferralTypeModal from './NewReferralTypeModal';

export default NewReferralTypeModal;
